import React, { useState, useEffect } from "react";
import styles from "../../../styles/components/feedback.module.scss";
import Icons from "../../../public/assets/svg";
import BasicForm from "../../basicForm";
import { useRouter } from "next/router";
import axios from "axios";
import Loader from "../../Loader";
import _get from "lodash/get";
import {
  sessionTimeOutCheck,
  checkExpiry,
} from "../../../redux/global/actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import endpoints from "../../../utility/endpoints";
import { BlobServiceClient } from "@azure/storage-blob";
const ModalExample = (props) => {
  //console.log("Props soft skill ---", props);

  const sucessFailure =
  props.data[1].component.content.field_message_type_value_pair;
  const requestDemoInfo = props.data[0].component.content;
  const {
    field_title,
    field_message_input,
    field_options,
    field_request_demo_form_componen,
  } = requestDemoInfo;


  const modalRef = React.useRef(null);

  // method to close the modal if clicked outside
  function useOutsideAlerter(ref) {
    useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          //props.closeModal();
        }
      }
      // Bind the event listener
      document.addEventListener("click", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("click", handleClickOutside);
      };
    }, [ref]);
  }
  useOutsideAlerter(modalRef);

  const router = useRouter();
  
  const initialState = {
    "Rating": "",
    "Description": "",

  };
  const rawErrorData = {
    name: false,
}

  const [state, setState] = React.useState(initialState);
  const [stateError, setStateError] = useState(rawErrorData);
  const [items, setItems] = useState([]);
  const [sskillid,setSskillid]=React.useState("");
  const [successModal, setSuccessModal] = useState(false);
  const [submitForm, setSubmitForm] = React.useState(false);
  const [getFormValues, setGetFormValues] = React.useState(false);
  const [emptyFormValues, setEmptyFormValues] = React.useState(false);
  const [Loading, setLoading] = React.useState(false);
  const [msg, setMsg] = React.useState(false);
  

  const remarkComponent=props.data[0].component.content.field_request_demo_form_componen[0];
  const feedbackname=props.data[0].component.content.field_request_demo_form_componen[1];
  const softskillForm = () => {
    setGetFormValues(true);
  };

  const onValueChange = async (e) => {
    const value = e.target.value;
    
      
      setState({
        ...state,
        [e.target.id]: value,
      });
    
   

    
    if (e.target.value ) {
      setStateError({ ...stateError, [e.target.id]: "valid" });
    } 
    else {
      setStateError({ ...stateError, [e.target.id]: true });
    }

}


  const onFromSubmit = async () => {

      setSubmitForm(true);
      let authCheck = JSON.parse(localStorage.getItem("auth")).data;
      let expiryStatus = await props.checkExpiry(authCheck);
      let moveAhead = true;

      if(state.Rating==""||state.Description==""){
      }

     else{
        if (expiryStatus) {
            let auth = await JSON.parse(localStorage.getItem("auth")).data;
            axios({
              method: "POST",
              url: `${endpoints.baseUrl}/twin/feedback`,
              headers: {
                Authorization: `${auth.accessToken}|${auth.email}`,
              },
              data: {
                ...state,
              },
            }).then((resp) => {
              if (resp.data.code == 403) {
                props.closeModal();
                props.setSuccessModal(true);
                props.setMessage(sucessFailure[0].field_message);
                setLoading(true);
                props.setSuccessModal(true);
              
              } 
              else if (resp.status == 200) {
                setLoading(true);
                setMsg(true);
                props.closeModal();
                props.setSuccessModal(true);
                props.setMessage(sucessFailure[0].field_message);
                setLoading(true);
                props.setSuccessModal(true);
              } 
              else if (resp.data.code == 400) {
               
                props.closeModal();
                props.setSuccessModal(true);
                props.setMessage(sucessFailure[0].field_message);
                setLoading(true);
                props.setSuccessModal(true);
              }
            });
          } else {
            setLoading(false)
            props.sessionTimeOutCheck(true);
            
          }
        }
    
  };

  const handledemo = () => {
    props.closeModal();
    document.body.style.overflow = "unset";
  };
  //console.log("iteam_check------>" , items)
 

  
 
  return (
    <div className={styles.editModalWrapper}>
      {Loading ? (
        <Loader />
      ) : (
        <div className={styles.modalBox} ref={modalRef}>
        <div className={`${styles.formContainer}`}>
          <div className="container">
          
           
              <span
                className={styles.rowBtn}
                onClick={() => {
                  handledemo();
                }}
              >
                <div className={styles.icon}>
                    <img src="https://bnlwestgunileveraf01091.blob.core.windows.net/botstorevideo/employeetwin/close.png" className={styles.iconimg}/>
                </div>
              </span>
             
              <div className="col-md-12">
                <h2 className={styles.head}>Feedback Form </h2>
                {msg?
                <p>Your Feedback sent successfully</p>:null}
              </div>
            
            </div>
            </div>
         
         
          <div className={styles.modalBody}>
            
            {/* <div className={styles.detailsSec}> */}
            <div className={styles.row}>
             
            </div>
            <div className={styles.row}>

              <div className="col-lg-12 col-md-12 col-12">
              <div className={styles.formGroup}>
                <div className={styles.combine}>
                  <label className={styles.mainLabel}>
                    {_get(
                      feedbackname,
                      "field_form_field_title",
                      ""
                    )}
                    <sup className={styles.mandatoryField}>*</sup>
                    {submitForm?
                    (state.Rating == "" && state.Rating.length == 0)?(
                    <span className={styles.errorMessage}>
                      {_get(
                        feedbackname,
                        "field_message_ip_error_message",
                        ""
                      )}
                    </span>
                  ) : null:null
                  }
                  </label>
                </div>

                <input
                  type="text"
                  className={styles.inputtext}
                  id="Rating"
                  name="Rating"
                  onChange={onValueChange}
                />
              </div>
              </div>
              <div className="col-lg-12 col-md-12 col-12">
                <div className={styles.formGroup}>
                  <div className={styles.labelstyle}>
                    <label>
                    {_get(
                      remarkComponent,
                      "field_form_field_title",
                      ""
                    )}
                    <sup className={styles.mandatoryField}>*</sup>
                    {submitForm?
                    (state.Description == "" && state.Description.length == 0)?(
                    <span className={styles.errorMessage}>
                      {_get(
                        feedbackname,
                        "field_message_ip_error_message",
                        ""
                      )}
                    </span>
                  ) : null:null
                  }
                    </label>
                  </div>

                  <textarea
                    // className={`${invalidFlag ? styles.errorBorder : null}`}
                    placeholder={remarkComponent.field_title}
                    id="Description"
                    name="Description"
                    onChange={onValueChange}
                  ></textarea>
                </div>
              </div>
           
            </div>
            {/* </div> */}
          </div>
          <div className={styles.modalFooter}>
            <div className={styles.combinedBtn}>
           
              <span
                className={styles.exportListBtn}
                onClick={onFromSubmit}
              >
                {field_options[0]}
              </span>
            </div>
          </div>
        </div>
      )}
      {successModal ? (
          <SuccessModal
            setSuccessModal={() => {
              setSuccessModal(false);
              setFileNameError(false);
            }}
            title={"Framework"}
            message={
              filenameError
                ? "Document with this name already exists."
                : message
            }
            fail={filenameError ? true : false}
          />
        ) : null}
    </div>
  );
};

const mapStateToProps = (state) => {
  //console.log("state", state);
  return {
    session: state.session.session,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    sessionTimeOutCheck: bindActionCreators(sessionTimeOutCheck, dispatch),
    checkExpiry: bindActionCreators(checkExpiry, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalExample);

